/**
 * The function checks if an object is empty by checking if it has no keys.
 * @param {object} obj - The parameter "obj" is of type "object", which means it can accept any
 * JavaScript object as an argument.
 */
export const isEmptyObject = obj => Object.keys(obj).length === 0;
//# sourceMappingURL=isEmptyObject.js.map